import { BusinessAggridDataPacket } from "selectors/aggrid/businesses";

const rowWithCountByRow = new WeakMap<
  BusinessAggridDataPacket,
  BusinessAggridDataPacket
>();

// Carried on the row rather than resolved in a valueGetter so a count arriving
// reaches the grid as a row data change, which re-sorts and re-filters. Rows
// whose count hasn't changed are reused so the grid only updates those that
// have.
export function withSideLoadedSuggestionCounts(
  rows: BusinessAggridDataPacket[],
  countByBusinessId: Record<string, number> | null,
): BusinessAggridDataPacket[] {
  if (!countByBusinessId) {
    return rows;
  }
  return rows.map(row => {
    const sideLoadedSuggestionCount = countByBusinessId[row.id] ?? null;
    const previous = rowWithCountByRow.get(row);
    if (previous?.sideLoadedSuggestionCount === sideLoadedSuggestionCount) {
      return previous;
    }
    const rowWithCount = { ...row, sideLoadedSuggestionCount };
    rowWithCountByRow.set(row, rowWithCount);
    return rowWithCount;
  });
}
